export const width = {
    wid1: 1,
    wid2:2,
    wid8:8,
    wid10:10,
    wid28:28,
    wid40:40,
    wid50:50,
    wid80:80,
    wid100:100,
    wid110: 110,
    wid125 : 125,
    wid130: 130,
    wid150: 150, 
    wid160: 160,
    wid175: 175,
    wid180: 180,
    wid200: 200,
    wid215: 215,
    wid220: 220, 
    wid250: 250,
    wid300: 300, 
    wid350: 350,
    wid400: 400,
    wid500: 500,
    wid736 : 736,
    wid1500 : 1500,
    wid1200: 1200
};
  